// removed by extract-text-webpack-plugin
module.exports = {"left":"E6KjL","right":"_27Dq4","row":"_3x5Bv","avatarHeader":"PDkDH","titleHeader":"_3IBpB","iconHeader":"_3QeC7","timeAgoHeader":"_3nZw1","moreButtonHeader":"_2WYlL"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-list-classic-header/post-list-classic-header.scss
// module id = 1532
// module chunks = 0